// extracted by mini-css-extract-plugin
module.exports = {"loadingGrid":"ClassFeedSetter_loadingGrid__3W91y","loadingText":"ClassFeedSetter_loadingText__1kQCw"};